var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558 1237 c-88 -72 -183 -112 -294 -123 -73 -8 -116 -30 -144 -76 -18 -29 -20 -51 -20 -188 0 -364 78 -568 271 -715 82 -61 222 -129 271 -129 24 0 72 17 144 53 92 46 121 67 190 136 66 65 89 98 122 166 22 46 47 111 55 144 22 81 41 309 35 415 -8 142 -37 174 -177 195 -47 7 -102 19 -121 26 -49 18 -126 64 -174 105 -56 48 -90 46 -158 -9z m193 -113 c61 -38 132 -63 232 -80 136 -23 130 -12 124 -244 -6 -223 -21 -303 -84 -422 -65 -123 -198 -236 -336 -283 l-54 -18 -98 47 c-168 82 -280 216 -328 391 -30 109 -47 406 -28 475 8 29 43 43 149 59 87 13 196 62 266 119 l50 41 34 -30 c18 -16 51 -41 73 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574 892 c-102 -48 -131 -174 -60 -259 20 -24 24 -42 27 -111 4 -80 6 -85 37 -113 35 -31 66 -36 107 -17 38 17 55 58 55 133 0 59 3 70 32 106 43 53 50 129 19 186 -45 80 -138 112 -217 75z m123 -77 c29 -20 46 -75 34 -106 -5 -13 -21 -35 -35 -48 -23 -22 -26 -32 -26 -97 0 -85 -6 -104 -31 -104 -17 0 -19 8 -19 85 0 83 -1 85 -35 119 -44 45 -47 90 -9 135 20 24 34 31 63 31 20 0 46 -7 58 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.7e67a0870236bc0598936e6358601844.svg";
export { ForwardRef as ReactComponent };